import { IOptions } from '@acorn-portal/shared/src/components/inputs/select';
import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';

const useVehicleUsageOptions = (): IOptions[] => {
	const lists = useAppSelector((redux) => redux.referenceData);
	return (
		(lists.vehicleUseOptions?.filter(
			(option) => (option?.value as string) === '15' || (option?.value as string) === '17',
		) as IOptions[]) || []
	);
};

export default useVehicleUsageOptions;
